[
  { "id": "none", "title": "(None)", "src": "" },
  { "id": "teal", "title": "Teal", "src": "./wallpapers/teal.webp", "pixelated": true },
  { "id": "siggy", "title": "Siggy", "src": "./wallpapers/siggy.jpg" },
  { "id": "supes", "title": "Supes", "src": "./wallpapers/supes.jpg" }
]
